export function getText(locations) {
  return locations.length === 1 ? '1 location' : `${locations.length} locations`
}
